// src/lib/opportunity/formatSettingsTypes.ts

import type { OpportunityFormatKey } from "../../types/opportunity.js";

export const DEFAULT_BASE_AMOUNT_LABEL = "Base amount";
export const BASE_AMOUNT_LABEL_MAX_LEN = 120;

export type FormatSettings = {
  id: string;
  organization_id: string;
  format_key: OpportunityFormatKey;
  product_type: string;
  base_amount_label: string;
  updated_by_user_id: string | null;
  created_at: string;
  updated_at: string;
};

export type FormatSettingsDef = Pick<FormatSettings, "base_amount_label">;

export const DEFAULT_FORMAT_SETTINGS: FormatSettingsDef = {
  base_amount_label: DEFAULT_BASE_AMOUNT_LABEL,
};

/** Product-specific settings win; otherwise use the org `*` template. */
export function selectFormatSettings(args: {
  rows: FormatSettings[];
  productType: string;
}): FormatSettingsDef {
  const specific = args.rows.find((r) => r.product_type === args.productType);
  if (specific) return { base_amount_label: specific.base_amount_label };
  const wildcard = args.rows.find((r) => r.product_type === "*");
  if (wildcard) return { base_amount_label: wildcard.base_amount_label };
  return DEFAULT_FORMAT_SETTINGS;
}
